import { render } from "./MembershipBenefit.vue?vue&type=template&id=3016c0d4&scoped=true"
import script from "./MembershipBenefit.vue?vue&type=script&lang=js"
export * from "./MembershipBenefit.vue?vue&type=script&lang=js"

import "./MembershipBenefit.vue?vue&type=style&index=0&id=3016c0d4&scoped=true&lang=css"

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3016c0d4"]])

export default __exports__